module.exports = __webpack_public_path__ + "img/pump-0.b9ec8072.png";